module.exports = __webpack_public_path__ + "static/img/pinggu-03.2ef2747.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pinggu-03.png
// module id = xDXF
// module chunks = 1